require('./mortgageRequestAppraisalRequestStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
const Immutable = require('immutable');
//@ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const MortgageRequestFormattedAddress = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');
const MortgageRequestFormattedRegistryData = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedRegistryData/mortgageRequestFormattedRegistryData');
const MortgageRequestAnnexConstructions = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestAnnexConstructions/mortgageRequestAnnexConstructions');
const MortgageRequestAppraisalRequestCostWafer = require('components/mortgageRequest/mortgageRequestAppraisalRequest/mortgageRequestAppraisalRequestCostWafer/mortgageRequestAppraisalRequestCostWafer');
// @ constants
const { ESTATES_TYPE_ABBREVIATION, ESTATE_REGISRATION_TYPE } = require('constants/mortgageRequestEstates');
const { PLURAL_CHARACTER } = require('constants/index');

class MortgageRequestAppraisalRequestStep1 extends React.Component {
    buildAddressContent(immEstate) {
        return (
            <OKInformativeListItem
                title="mortgageRequestAppraisalRequest-step1LivingPlace"
                compact={true}
            >
                <MortgageRequestFormattedAddress
                    immEstate={immEstate}
                    className="mortgage-request-appraisal-request-step-one__text"
                />
            </OKInformativeListItem>
        );
    }

    buildAnotherContructionsLabel(immLivingPlace, immAnnexConstructions) {
        let labelContent;

        if (immLivingPlace && immAnnexConstructions.size > 0) {
            labelContent = (
                <FormattedText
                    value="mortgageRequestAppraisalRequest-step1AnotherContructions"
                    className="mortgage-request-appraisal-request-step-one__label"
                />
            );
        }

        return labelContent;
    }

    buildGaragesContent(garages) {
        let garagesContent = '';

        if (garages > 0) {
            const pluralPostfix = garages !== 1 ? PLURAL_CHARACTER : '';
            garagesContent = formatText('mortgageRequestAppraisalRequest-step1Garages', [garages, pluralPostfix]);
        }

        return garagesContent;
    }

    buildIdufirContent(immEstate) {
        let udifirContent;
        const idufir = immEstate.get('idufir');

        if (!!idufir) {
            udifirContent = (
                <OKInformativeListItem
                    title="mortgageRequestAppraisalRequest-step1Code"
                    compact={true}
                >
                    <span className="mortgage-request-appraisal-request-step-one__text">{idufir}</span>
                </OKInformativeListItem>
            );
        }

        return udifirContent;
    }

    buildInlcudeContent(immLivingPlace) {
        const storageRooms = parseInt(immLivingPlace.get('storageRooms'), 0);
        const garages = parseInt(immLivingPlace.get('garages'), 0);

        let includeContent;

        if (storageRooms > 0 || garages > 0) {
            const storageRoomsContent = this.buildStorageRoomsContent(storageRooms);
            const garagesContent = this.buildGaragesContent(garages);

            let title;
            let includeConnector = '';

            if (storageRooms > 0 && garages > 0) {
                includeConnector = formatText('mortgageRequestAppraisalRequest-step1IncludeConnector');
            }

            title = formatText('mortgageRequestAppraisalRequest-step1Include', [storageRoomsContent, includeConnector, garagesContent]);

            includeContent = (
                <OKInformativeListItem title={title} />
            );
        }

        return includeContent;
    }

    buildLivingPlaceContent(immLivingPlace) {
        let livingPlaceContent;

        if (immLivingPlace) {
            const addressContent = this.buildAddressContent(immLivingPlace);
            const idufirContent = this.buildIdufirContent(immLivingPlace);
            const registryDataContent = this.buildRegistryDataContent(immLivingPlace);
            const inlcludeContent = this.buildInlcudeContent(immLivingPlace);

            livingPlaceContent = (
                <OKInformativeList>
                    {addressContent}
                    {idufirContent}
                    {registryDataContent}
                    {inlcludeContent}
                </OKInformativeList>
            );
        }

        return livingPlaceContent;
    }

    buildRegistryDataContent(immEstate) {
        let registryDataContent;
        const idType = immEstate.get('idType');
        const isRegData = idType === ESTATE_REGISRATION_TYPE.REG || idType === ESTATE_REGISRATION_TYPE.REG_DATA;

        if (!immEstate.get('udifir') && isRegData) {
            registryDataContent = (
                <OKInformativeListItem
                    title="mortgageRequestAppraisalRequest-step1RegistryData"
                    compact={true}
                >
                    <MortgageRequestFormattedRegistryData
                        immEstate={immEstate}
                        className="mortgage-request-appraisal-request-step-one__text"
                    />
                </OKInformativeListItem>
            );
        }

        return registryDataContent;
    }

    buildStorageRoomsContent(storageRooms) {
        let storageRoomsContent = '';

        if (storageRooms > 0) {
            const pluralPostfix = storageRooms !== 1 ? PLURAL_CHARACTER : '';
            storageRoomsContent = formatText('mortgageRequestAppraisalRequest-step1StorageRoom', [storageRooms, pluralPostfix]);
        }

        return storageRoomsContent;
    }

    render() {
        const { immEstates, immPayment } = this.props;
        const immLivingPlace = immEstates.get('list').find(immEstate =>
            immEstate.get('propertyType') === ESTATES_TYPE_ABBREVIATION.VIVIENDA
        );
        const livingPlaceContent = this.buildLivingPlaceContent(immLivingPlace);
        const title = formatText('mortgageRequestAppraisalRequest-step1Title');
        const subtitle = formatText('mortgageRequestAppraisalRequest-step1Subtitle');
        const authorizationPayment = formatText('mortgageRequestAppraisalRequest-mortgageRequestAppraisalRequest_authorizationPayment');
        const immAnnexConstructions = Immutable.fromJS(immEstates.get('list').reduce((annexContructions, immEstate) => {
            if (immEstate.get('propertyType') !== ESTATES_TYPE_ABBREVIATION.VIVIENDA) {
                annexContructions.push(immEstate);
            }

            return annexContructions;
        }, []));
        const anotherConstructionsLabel = this.buildAnotherContructionsLabel(immLivingPlace, immAnnexConstructions);

        let content;

        if (immEstates.get('isFetching') || immPayment.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            content = (
                <div className="mortgage-request-appraisal-request-step-one">
                    <header className="mortgage-request-appraisal-request-step-one__title">
                        {title}
                    </header>
                    <div className="mortgage-request-appraisal-request-step-one__subtitle">
                        {subtitle}
                    </div>
                    <div className="mortgage-request-appraisal-request-step-one__content">
                        {livingPlaceContent}
                        {anotherConstructionsLabel}
                        <MortgageRequestAnnexConstructions
                            immAnnexConstructions={immAnnexConstructions}
                        />
                    </div>
                    <MortgageRequestAppraisalRequestCostWafer
                        immPayment={immPayment}
                    />
                    <div className="mortgage-request-appraisal-request-step-one__important-msg">
                        <OKMessage type="important">
                            {authorizationPayment}
                        </OKMessage>
                    </div>
                    <div className="mortgage-request-appraisal-request-step-one__informative-msg">
                        <OKMessage type="informative">
                            <FormattedText value="mortgageRequestAppraisalRequest-mortgageRequestAppraisalRequest_informativePayment"></FormattedText>
                        </OKMessage>
                    </div>
                </div>
            );
        }

        return content;
    }
}

MortgageRequestAppraisalRequestStep1.propTypes = {
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired
};

module.exports = MortgageRequestAppraisalRequestStep1;
